export const isAcceptsAfter = (components, componentIds) => {
    if (Array.isArray(componentIds)) {
        return true;
    }
    return (components[componentIds].acceptsAfter !== false);
};
export const isAcceptsBefore = (components, componentIds) => {
    if (Array.isArray(componentIds)) {
        return true;
    }
    return (components[componentIds].acceptsBefore !== false);
};
export const fixAccepts = (compiledSlate, componentId, acceptsAfter, acceptsBefore) => {
    var _a;
    const component = compiledSlate.components[componentId];
    const parentAcceptsAfter = typeof acceptsAfter === 'undefined' ? true : acceptsAfter;
    const parentAcceptsBefore = typeof acceptsBefore === 'undefined' ? true : acceptsBefore;
    component.acceptsAfter =
        component.acceptsAfter !== false && parentAcceptsAfter;
    component.acceptsBefore =
        component.acceptsBefore !== false && parentAcceptsBefore;
    component.acceptsChildren = component.acceptsChildren === true;
    component.removable = component.removable !== false;
    (_a = compiledSlate.parentsMapping[componentId]) === null || _a === void 0 ? void 0 : _a.forEach(parent => fixAccepts(compiledSlate, parent, component.acceptsAfter, component.acceptsBefore));
};
//# sourceMappingURL=accepts.utils.js.map